import * as React from 'react';

import Key16 from './Key16';

export const key16 = () => <Key16 />;

export default {
    title: 'Icon|Line|Key16',
    component: Key16,
    parameters: {
        notes: "`import Key16 from 'box-ui-elements/es/icon/line/Key16';`",
    },
};
